import { TranslationCustomerMessages, CustomerMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationCustomerMessages = {
  [CustomerMessages.applicationDashboard]: "Início",
  [CustomerMessages.applicationConcretingRequest]: "Solicitação de Programação",
  [CustomerMessages.applicationConcretingRequestAbbreviated]: "Solicitação de Prog.",
  [CustomerMessages.applicationContract]: "Contratos",
  [CustomerMessages.applicationContractAmounts]: "Valor de Contrato",
  [CustomerMessages.applicationConcreting]: "Programações",
  [CustomerMessages.applicationInvoice]: "Faturas",
  [CustomerMessages.applicationConcretingApproval]: "Aprovação de programação",
  [CustomerMessages.applicationCertificate]: "Laudos",
  [CustomerMessages.applicationClient]: "Clientes",
  [CustomerMessages.applicationPermission]: "Permissões",
  [CustomerMessages.applicationLogout]: "Sair",
  [CustomerMessages.applicationSettings]: "Configurações",
  [CustomerMessages.applicationDocs]: "Documentação",
  [CustomerMessages.docsTabManual]: "Manual",
  [CustomerMessages.docsTabChangelog]: "Novidades",
  [CustomerMessages.docsIndexTitle]: "Índice",
  [CustomerMessages.docsVersionsTitle]: "Versões",
  [CustomerMessages.docsLoadError]: "Não foi possível carregar a documentação.",
  [CustomerMessages.docsNoVersions]: "Nenhuma versão encontrada.",
  [CustomerMessages.docsVersion]: "Versão <VERSION>",
  [CustomerMessages.docsWhatChanged]: "O que mudou",
  [CustomerMessages.docsDetails]: "Detalhes",
  [CustomerMessages.docsClose]: "Fechar",
  [CustomerMessages.docsCancel]: "Cancelar",
  [CustomerMessages.docsKindAddedLabel]: "Novo",
  [CustomerMessages.docsKindAddedOne]: "novidade",
  [CustomerMessages.docsKindAddedMany]: "novidades",
  [CustomerMessages.docsKindImprovedLabel]: "Melhorado",
  [CustomerMessages.docsKindImprovedOne]: "melhoria",
  [CustomerMessages.docsKindImprovedMany]: "melhorias",
  [CustomerMessages.docsKindFixedLabel]: "Corrigido",
  [CustomerMessages.docsKindFixedOne]: "correção",
  [CustomerMessages.docsKindFixedMany]: "correções",
  [CustomerMessages.docsKindBreakingLabel]: "Importante",
  [CustomerMessages.docsKindBreakingOne]: "mudança importante",
  [CustomerMessages.docsKindBreakingMany]: "mudanças importantes",
  [CustomerMessages.docsKindOtherLabel]: "Outro",
  [CustomerMessages.docsKindOtherOne]: "item",
  [CustomerMessages.docsKindOtherMany]: "itens",
  [CustomerMessages.docsVersionDetails]: "Novidades em detalhe",
  [CustomerMessages.docsVersionRange]: "Resumo de versões",
  [CustomerMessages.docsVersionNoDetails]: "A versão <LINE> ainda não tem detalhes",
  [CustomerMessages.docsVersionDetailsTitle]: "Novidades em detalhe · Versão <VERSION>",
  [CustomerMessages.docsVersionRangeTitle]: "Resumo de versões · <FROM> → <TO>",
  [CustomerMessages.docsVersionRangeDialogTitle]: "Resumo de versões",
  [CustomerMessages.docsVersionRangeHelp]:
    "Escolha até <MAX> linhas de versão, como 1.19.0 → 1.20.0. O resumo junta destaques, melhorias e correções.",
  [CustomerMessages.docsVersionFrom]: "De",
  [CustomerMessages.docsVersionTo]: "Até",
  [CustomerMessages.docsVersionRangeTooWide]: "O intervalo passa por <COUNT> linhas (<LINES>). Escolha até <MAX>.",
  [CustomerMessages.docsVersionOpenRange]: "Abrir resumo",
  [CustomerMessages.docsVersionLine]: "Linha <LINE>",
  [CustomerMessages.docsVersionFilter]: "Filtrar versão",
  [CustomerMessages.docsVersionNoOptions]: "Nenhuma versão",
  [CustomerMessages.newVersionBanner]: "Nova versão <VERSION>! Veja o que há de novo.",
  [CustomerMessages.newVersionSee]: "Ver novidades",
  [CustomerMessages.newVersionDismiss]: "Marcar como lido",
  [CustomerMessages.newBadge]: "Novo",
  [CustomerMessages.allUsersStatusIconTitle]: "Todos usuários",
  [CustomerMessages.newUsersStatusIconTitle]: "Novos usuários",
  [CustomerMessages.activeUsersStatusIconTitle]: "Usuários ativos",
  [CustomerMessages.inactiveUsersStatusIconTitle]: "Usuários inativados",
  [CustomerMessages.blockedUsersStatusIconTitle]: "Usuários bloqueados",
  [CustomerMessages.inactivedUser]: "Usuário inativado",
  [CustomerMessages.activedUser]: "Usuário ativado",
  [CustomerMessages.errorInactivatingUser]: "Erro ao inativar usuário",
  [CustomerMessages.errorActivatingUser]: "Erro ao ativar usuário",
  [CustomerMessages.inactivateUserTitle]: "Inativar usuário",
  [CustomerMessages.activateUserTitle]: "Ativar usuário",
  [CustomerMessages.inactivateUserText]: "Deseja inativar o usuário <USER_NAME>?",
  [CustomerMessages.activateUserText]: "Deseja ativar o usuário <USER_NAME>?",
  [CustomerMessages.activateUserButton]: "Ativar",
  [CustomerMessages.inactivateUserButton]: "Inativar"
};
